<template>
  <div>
    <nav class="add-navigation">
      <search-input
        class="search-input"
        type="text"
        v-model="SearchSuppression"
        @keyup.native="getSuppressionsList"
        placeholder="Search for Suppression"
      />
      <div class="buttons-wrapper">
        <div class="primary-button">
          <primary-button
            @click.native="$router.push({name: 'system-admin-dids-add-suppression'})"
          >Add Suppression</primary-button>
        </div>
      </div>
    </nav>
    <table class="Invoice_table">
      <thead>
        <tr class="Invoice_table_header">
          <th class="table_header_item">Number</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="line"
          v-if="suppressions.length > 0"
          v-for="(suppression, k) in suppressions"
          :key="k"
        >
          <th class="content">{{suppression.number}}</th>
          <th class="icon-right">
            <svg
              @click="deleteSuppression(suppression.id)"
              class="svg-grey"
              width="30px"
              height="30px"
              viewBox="0 0 30 30"
              version="1.1"
            >
              <path
                d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                id="path-1"
              />
            </svg>
          </th>
        </tr>
      </tbody>
    </table>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :total="TotalPages"
        :perPage="per_page"
        :qnt="suppressions.length"
      />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    DownloadAttachmentDropDown: () =>
      import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue")
  },
  data: () => ({
    suppressions: [],
    SearchSuppression: "",
    Page: 0,
    number: "",
    TotalPages: "",
    per_page: 10
  }),
  created() {
    this.getSuppressionsList();
  },
  methods: {
    changePage(page) {
      this.Page = page;
      this.getSuppressionsList(this.SearchSuppression, this.Page);
    },
    getSuppressionsList() {
      this.$store
        .dispatch("GetSuppressionNumbers", {
          page: this.Page,
          number: this.SearchSuppression
        })
        .then(res => {
          console.log("res--->", res);
          this.suppressions = res.items.map(this.transformInvoices);
          this.TotalPages = res.total / res.per_page;
        });
    },
    transformInvoices(i, k) {
      return {
        number: i.number,
        id: i.suppressed_number_uuid
      };
    },
    deleteSuppression(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this suppression!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("DeleteSuppressionNumber", id)
            .then(res => {
              console.log("res--->", res);
              this.getSuppressionsList();
              this.$swal(
                "Deleted!",
                "Suppression has been deleted.",
                "success"
              );
            })
            .catch(err => {
              this.$snotify.error(err.response.statusText);
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.add-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  .search-input {
    background-color: #ffffff;
    height: 36px;
    width: 417px;
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: fit-content;
    .primary-button {
      height: 40px;
      width: 160px;
    }
  }
}
table.Invoice_table {
  width: 100%;
}
table thead tr {
  background: #f8f9fe;
}
table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 12px 0 12px 15px;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  color: #212b36;
  font-family: "Helvetica Neue";
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  padding: 11px 10px;
}
.Invoice_table_header .table_header_item {
  float: left;
}
tbody th {
  color: #212b36;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 15px 10px;
}
tbody th.content {
  float: left;
}
tbody th.icon-right {
  padding: 7px 20px 7px 0;
  height: 30px;
  width: 30px;
  fill: #55616e;
}
.Invoice_price {
  font-family: "Helvetica Neue";
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 25px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding-left: 32px;
}
</style>

